import _ from "./index.es106.js";

var o = _.t("component_component_timePickerPromptLabel_selectHHMMSS"),
    E = _.t("component_component_timePickerPromptLabel_selectHHMM"),
    n = _.t("component_component_timePickerPromptLabel_selectTime"),
    c = [2, 5, 13, 16],
    O = [2, 10],
    e = [2, 5],
    I = /^\d{1,2}:\d{1,2}(:\d{1,2})?$/,
    R = [5, 8, 9, 11],
    t = 60,
    s = t * 60,
    A = 24,
    T = 6,
    N = 2,
    m = 10;

export { R as DASH_AROUND_SPACES, e as DIVIDER_POSITIONS, m as DIVISOR_FOR_LAST_DIGIT, N as HOURS_EXTREME_VALUE, A as HOURS_IN_DAY, E as PLACEHOLDER_MASK, o as PLACEHOLDER_MASK_WITH_SECONDS, n as PLACEHOLDER_SINGLE, s as SECONDS_IN_HOUR, t as SECONDS_IN_MINUTE, T as SECONDS_OR_MINUTES_EXTREME_VALUE, O as SHORT_SEPARATOR_POSITIONS, c as SHORT_SEPARATOR_POSITIONS_WITH_SECONDS, I as SINGLE_TIME_MASK_REG };